import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconUserCheck } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface TeacherListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const TeacherListItem: React.FC<TeacherListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconUserCheck}
    typeLabel="Teacher"
    testId="teacher-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.LEARN }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default TeacherListItem
